const terms = () => import('../views/nca/terms.vue')
const schedule = () => import('../views/nca/schedule.vue')

export default [
  {
    path: '/nca/terms/:survNo',
    name: 'terms',
    props: true,
    component: terms
  },
  {
    path: '/nca/schedule/:survNo/:userNo',
    name: 'schedule',
    props: true,
    component: schedule
  }
]
